import { Moment } from "moment";

export interface RecurrenceModel {
    recurring: boolean;
    type: RecurrenceType;
    everyNthOccurrence: number;
    startDate: Moment;
    endDateMode: EndDateMode;
    endDate: Moment | null;
    maxOccurrences: number;
    // Daily data
    dailyMode: DailyMode
    // Weekly data
    weekdays: WeekDaysToggle;
    // Monthly data
    monthlyMode: MonthlyMode;
    onDay?: number;
    dayRule: DayRule;
    dayRuleDay: DayRuleDay;
}

export enum DayRuleDay {
    Monday = "monday",
    Tuesday = "tuesday",
    Wednesday = "wednesday",
    Thursday = "thursday",
    Friday = "friday",
    Saturday = "saturday",
    Sunday = "sunday",
    Day = "day",
    Weekday = "weekday",
    WeekendDay = "weekendDay"
}

export enum DayRule {
    First = "first",
    Second = "second",
    Third = "third",
    Fourth = "fourth",
    Last = "last"
}

export enum DailyMode {
    EveryNthDay = "everyNthDay",
    EveryWeekday = "everyWeekday"
}

export enum MonthlyMode {
    OnDay = "onDay",
    DayRule = "dayRule"
}

type EndDateMode = "noEndDate" | "afterOccurrences" | "withEndDate";

interface WeekDaysToggle {
    monday: boolean;
    tuesday: boolean;
    wednesday: boolean;
    thursday: boolean;
    friday: boolean;
    saturday: boolean;
    sunday: boolean;
}

export const weekdaySelected = (vals: WeekDaysToggle): boolean => {
    return vals.monday || vals.tuesday || vals.wednesday || vals.thursday || vals.friday || vals.saturday || vals.sunday;
}

export type RecurrenceType = "daily" | "weekly" | "monthly";

export const getEmptyRecurrenceModel = (startDate: Moment): RecurrenceModel => {
    const endDate = startDate.clone().add(1, "days");
    return {
        recurring: false,
        type: "weekly",
        startDate,
        endDateMode: "afterOccurrences",
        endDate,
        maxOccurrences: 1,
        everyNthOccurrence: 1,
        dailyMode: DailyMode.EveryNthDay,
        weekdays: {
            monday: false,
            tuesday: false,
            wednesday: false,
            thursday: false,
            friday: false,
            saturday: false,
            sunday: false
        },
        monthlyMode: MonthlyMode.OnDay,
        onDay: 1,
        dayRule: DayRule.First,
        dayRuleDay: DayRuleDay.Day
    }
}


// WEBPACK FOOTER //
// ./src/common/models/Recurrence.ts